module.exports = __webpack_public_path__ + "media/images/ecalls/04_how_it_works_2-c80148fd5c6d929d21832bb0fe9cca51.png";